import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const Footer = () => {
    return(
        <Box mt="80px" bgcolor="#98D7E6">
            <Stack gap="40px" alignItems="center" px="40px" pt="24px">
                <Typography variant="h5" pb="40px" mt="40px">Made by Andrew Ly!</Typography>
            </Stack>
        </Box>
    )
}

export default Footer